module.exports = __webpack_public_path__ + "fonts/deposit-guide-2.67f1f9d2s.png";